(() => {
  if (customElements.get('product-recommendations')) {
    return;
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initShopifyRecommendations();
    }

    initShopifyRecommendations() {
      fetch(this.dataset.url).then(response => response.text()).then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          this.initSlider();
        }
      }).catch(e => {
        console.error(e);
      });
    }

    initSlider() {
      if (!this.querySelector('[data-product-carousel] .swiper')) return;

      this.options = {
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          }
        },
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true
        }
      };

      this.slider = new Swiper(
        this.querySelector('[data-product-carousel] .swiper'),
        this.options,
      );
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
